import { render, staticRenderFns } from "./wiki_notes_activity_header.vue.js?vue&type=template&id=0ed8d5ce&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./wiki_notes_activity_header.vue?vue&type=template&id=0ed8d5ce&vue3"
import script from "./wiki_notes_activity_header.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./wiki_notes_activity_header.vue?vue&type=script&lang=js&vue3"
export * from "./wiki_notes_activity_header.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./wiki_notes_activity_header.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports